<template>
  <div :class="classes"></div>
</template>

<script>
  export default {
    name: 'PanelResizer',
    props: {
      split: {
        type: String,
        validator (value) {
          return ['vertical', 'horizontal'].indexOf(value) >= 0
        },
        required: true
      },
      className: String
    },
    computed: {
      classes () {
        const classes = ['splitter-pane-resizer', this.split, this.className]
        return classes.join(' ')
      }
    }
  }
</script>

<style scoped>

</style>
